export const TINT_ONLY_MAX_TINTABLE_AMOUNT = 1;
export const MANUAL_ADDITION_OVER_MAX_TINTABLE_AMOUNT = 2;
export const REFILL_DURING_TINTING = 3;
export const MANUAL_ADDITION_FOR_CUSTOM_CAN = 4;
